import {HttpClient} from 'core/base/HttpClient';
import {IHttpClientResponse, TResponse} from 'core/types';
import {IEmailData, ILoginPasswordData, IPhoneData, IRestorePasswordData} from 'modules/auth/types';

export class AuthService extends HttpClient {
    // public authByLogin(email: string, password: string): Promise<IHttpClientResponse<TResponse>> {
    //     return this.post<ILoginPasswordData, TResponse>({
    //         body: {
    //             email,
    //             password,
    //         },
    //         options: {credentials: 'include'},
    //         url: '/auth/by-login',
    //     });
    // }

    public authByEmail(email: string): Promise<IHttpClientResponse<TResponse>> {
        return this.post<IEmailData, TResponse>({
            body: {
                email,
            },
            options: {credentials: 'include'},
            url: '/auth/by-email',
        });
    }

    public authByEmailAndPassword(email: string, password: string): Promise<IHttpClientResponse<TResponse>> {
        return this.post<ILoginPasswordData, TResponse>({
            body: {
                email,
                password,
            },
            options: {credentials: 'include'},
            url: '/auth/by-email',
        });
    }

    public async authByPhone(values: IPhoneData): Promise<IHttpClientResponse<TResponse>> {
        return this.post<IPhoneData, TResponse>({
            body: values,
            options: {credentials: 'include'},
            url: '/auth/by-phone',
        });
    }

    public async authLogout(): Promise<IHttpClientResponse<TResponse>> {
        return this.post<RequestInit, TResponse>({
            options: {credentials: 'include'},
            url: '/auth/logout',
        });
    }

    public async passwordRecover(email: string): Promise<IHttpClientResponse<TResponse>> {
        return this.post<IRestorePasswordData, TResponse>({
            body: {
                email,
            },
            options: {credentials: 'include'},
            url: '/auth/forgot',
        });
    }

    public async passwordUpdate(email: string, password: string): Promise<IHttpClientResponse<TResponse>> {
        return this.post<ILoginPasswordData, TResponse>({
            body: {
                email,
                password,
            },
            options: {credentials: 'include'},
            url: '/auth/forgot/set-new-password',
        });
    }
}
